import React, { createContext, FC, useState } from 'react';

const useGetCurrentProgressContextValue = () => {
  const [environment, setEnvironment] = useState<string>();

  return {
    environment,
    setEnvironment,
  };
};

export type GetCurrentProgressContext = ReturnType<typeof useGetCurrentProgressContextValue>;

const getCurrentProgressContext = createContext<GetCurrentProgressContext | null>(null);

export const GetCurrentProgressProvider: FC = ({ children }) => {
  const value = useGetCurrentProgressContextValue();
  return (
    <getCurrentProgressContext.Provider value={value}>
      {children}
    </getCurrentProgressContext.Provider>
  );
};

export const useGetCurrentProgressContext = () => {
  const context = React.useContext(getCurrentProgressContext);
  if (!context) {
    throw new Error(
      'useGetCurrentProgressContext must be used within a GetCurrentProgressProvider',
    );
  }
  return context;
};

export default GetCurrentProgressProvider;
